import axios from "axios";
import type { OfficeOption } from "../types";

const API_BASE_URL = process.env.REACT_APP_API_BASEURL + "/DigitalAssets";

export const getDigitalAssetOffices = async (): Promise<OfficeOption[]> => {
  const response = await axios.get<OfficeOption[]>(
    `${API_BASE_URL}/OfficeDetailsForDigitalAssets`,
  );
  return response.data;
};
